module.exports = __webpack_public_path__ + "img/img21.c8c328b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img21.png
// module id = 177
// module chunks = 0